import './App.css';
import 'react-toastify/dist/ReactToastify.css';
import './theme/toastTheme.css';
import { Navigate, Route, RouterProvider, createBrowserRouter, createRoutesFromElements } from 'react-router-dom';
import Box from '@mui/joy/Box';
import { LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import Login from './pages/Login';
import WaitingPage from './pages/WaitingPage';
import PoliciesPage from './pages/Policies';
import PolicyWizardPage from './pages/PolicyWizard';
import OrderTable from './components/OrderTable';
import TasksPage from './pages/Tasks';
import TaskResult from './pages/TaskResult';
import Webhooks from './pages/Webhooks';
import ProfilePage from './pages/Profile';
import BasePage from './pages/BasePage';
import ProtectedRoute from './components/ProtectedRoute';
import PublicRoute from './components/PublicRoute';
import Registration from './pages/Registration';
import Agreement from './pages/Agreement';
import Comparison from './pages/Comparison';
import FunctionsPage from './pages/Functions';
import LandingPage from './pages/LandingPage';
import AgentsPage from './pages/agents';
import ApiDocsPage from './pages/ApiDocs';
import StoragePage from './pages/Storage';
import AppThemeProviders from './theme/AppThemeProviders';
import { appShellViewportSx } from './theme/shellStyles';
import ThemedToastContainer from './components/ThemedToastContainer';

const router = createBrowserRouter(
  createRoutesFromElements(
    <>
      <Route path="/" element={<LandingPage />} />
      <Route path="/app" element={<ProtectedRoute><BasePage /></ProtectedRoute>}>
        <Route path="" element={<Navigate to="/app/agents" replace />} />
        <Route path="tasks" element={<TasksPage />} />
        <Route path="profile" element={<ProfilePage />} />
        <Route path="tasks/result" element={<Navigate to="/app/tasks" replace />} />
        <Route path="tasks/result/:id" element={<TaskResult />} />
        <Route path="comparison" element={<Comparison />} />
        <Route path="webhooks" element={<Webhooks />} />
        <Route path="agents" element={<AgentsPage />} />
        <Route path="functions" element={<FunctionsPage />} />
        <Route path="api-docs" element={<ApiDocsPage />} />
        <Route path="storage" element={<StoragePage />} />
        <Route path="policies" element={<PoliciesPage />}>
          <Route path="" element={<OrderTable />} />
          <Route path="wizard" element={<PolicyWizardPage />} />
          <Route path="wizard/:id" element={<PolicyWizardPage />} />
        </Route>
        <Route path="loading" element={<WaitingPage />} />
      </Route>
      <Route path="/user-agreement" element={<Agreement />} />
      <Route
        path="/login"
        element={(
          <PublicRoute>
            <Login />
          </PublicRoute>
        )}
      />
      <Route
        path="/registration"
        element={(
          <PublicRoute>
            <Registration />
          </PublicRoute>
        )}
      />
    </>,
  ),
);

const App = () => (
  <AppThemeProviders>
    <LocalizationProvider dateAdapter={AdapterDayjs}>
      <Box sx={appShellViewportSx}>
        <ThemedToastContainer />
        <RouterProvider router={router} />
      </Box>
    </LocalizationProvider>
  </AppThemeProviders>
);

export default App;
